import { render } from "./Step1View.vue?vue&type=template&id=bb23d8b6&scoped=true"
import script from "./Step1View.vue?vue&type=script&lang=js"
export * from "./Step1View.vue?vue&type=script&lang=js"

import "./Step1View.vue?vue&type=style&index=0&id=bb23d8b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb23d8b6"]])

export default __exports__